import { useLang } from "@/context/LangContext";
import { CONTACT, FOOTER } from "@/constants/testIds";
import { Mail, MapPin, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      id="contacto"
      data-testid={FOOTER.root}
      className="bg-[#1E3F29] text-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-10" data-testid={CONTACT.section}>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#F26419] mb-4">
              {t("contact.kicker")}
            </p>
            <h2 className="font-display font-black text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tighter">
              {t("contact.title")}
            </h2>
            <p className="mt-6 text-white/80 max-w-md text-base leading-relaxed">
              {t("footer.tag")}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.3em] uppercase font-bold text-white/60 mb-3">
              {t("contact.email.label")}
            </p>
            <a
              data-testid={CONTACT.email}
              href="mailto:sustraiaventura@gmail.com"
              className="flex items-center gap-2 text-lg font-semibold hover:text-[#F26419] transition-colors break-all"
            >
              <Mail className="w-5 h-5 flex-shrink-0" />
              sustraiaventura@gmail.com
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.3em] uppercase font-bold text-white/60 mb-3">
              {t("contact.location.label")}
            </p>
            <p className="flex items-start gap-2 text-base">
              <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5 text-[#F26419]" />
              {t("contact.location.value")}
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#" aria-label="instagram" className="w-10 h-10 border border-white/30 flex items-center justify-center hover:bg-[#F26419] hover:border-[#F26419] transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" aria-label="facebook" className="w-10 h-10 border border-white/30 flex items-center justify-center hover:bg-[#F26419] hover:border-[#F26419] transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="overflow-hidden">
        <p className="font-display font-black text-[18vw] leading-[0.8] tracking-tighter text-white/10 text-center select-none px-4">
SUSTRAI
        </p>
      </div>

      <div className="border-t border-white/15">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs tracking-wider text-white/60">
          <span>© {year} Sustrai Aventura. {t("footer.rights")}</span>
          <span>Vizcaya · Cantabria · ES</span>
        </div>
      </div>
    </footer>
  );
}
